// ======================================
// Working with POSTS. Data
// ======================================

import {makeAutoObservable} from "mobx";
//local
import axiosInstance from "../axios";

class PublicStore {
  // STATE. Observable and computed part
  // ****** COMMON ******
  loading = false; // loading status for parts of the page
  btnLoading = false; // loading status for buttons
  commonSettings = null; // common application settings

  // ****** REQUESTS ******
  currentRequest = {}; // object of the current (viewed) request

  constructor() {
    makeAutoObservable(this);
  }

  // ACTIONS
  // ****** WORKING WITH PRF OFFERS LIST ******

  // getting one specific RFP (request)
  async getCurrentRequestInfo(id) {
    this.loading = true;
    try {
      const {data} = await axiosInstance.get(`public/rfp/buyer/${id}`, {id});
      this.currentRequest = data.rfp;
    } catch (e) {
      throw new Error(e);
    }
    this.loading = false;
  }

  // getting list of offers for specific RFP
  async getOffers(id) {
    const questions = this.currentRequest?.smartFormQuestions?.filter(
      (item) => item.type !== "heading"
    );

    return axiosInstance.get(`public/rfp/buyer/${id}/offers`).then(({data}) => {
      return data.map((item) => ({
        id: item.id,
        name: item.Proposal.Organization.name,
        offerValue: item.price,
        validUntil: item.validUntil,
        evaluate: item.evaluate,
        readed: item.readed,
        smartFormAnswers:
          item.smartFormAnswers && !!questions.length
            ? item.smartFormAnswers.map((item) => ({
                ...item,
                type: questions.find((question) => question.id === item.questionId)?.type,
              }))
            : item.smartFormAnswers,
      }));
    });
  }

  // getting list of offers for specific RFP
  async getCombinedOffers(id) {
    const questions = this.currentRequest?.smartFormQuestions?.filter(
      (item) => item.type !== "heading"
    );

    return axiosInstance.get(`public/rfp/buyer/${id}/combined-offers`).then(({data}) => {
      return {
        ...data,
        buyerOffers: data.buyerOffers.map((item) => ({
          ...item,
          name: item.Proposal.Organization.name,
          offerValue: item.price,
          smartFormAnswers:
            item.smartFormAnswers && !!questions.length
              ? item.smartFormAnswers.map((item) => ({
                  ...item,
                  type: questions.find((question) => question.id === item.questionId)
                    ?.type,
                }))
              : item.smartFormAnswers,
        })),
      };
    });
  }

  // download the offers xlsx file
  async downloadXLSX(id) {
    const {data} = await axiosInstance.get(`public/rfp/buyer/${id}/offers-xlsx`, {
      responseType: "blob",
    });
    return data;
  }

  // ****** WORKING WITH POSTS ******

  // getting all common settings
  async getCommonSettings() {
    try {
      const {data} = await axiosInstance.get("public/common-settings");
      this.commonSettings = data;
    } catch (e) {
      throw e;
    }
  }
}

const publicStore = new PublicStore();
export default publicStore;
